<template>
  <panel title="Search By Client">
    <v-flex
    pl-2
    pr-2>
    <v-text-field
      v-model="search"	
      label="Search by client name"
    />
    </v-flex>
  </panel>
</template>

<script>
import _ from 'lodash'
import ClientsService from '@/services/ClientsService'
import EventBus from '@/main'
import {mapState} from 'vuex'

export default {
	data () {
		return {
			search: ''
		}
	},
	watch: {
		search: _.debounce(async function (value) {
      let tempClients = (await ClientsService.index(this.search)).data
      if (tempClients) {
        await this.emitMethod('searchGroupClients', tempClients, this.search) 
      }
    }, 700)
	}, 
	async mounted () {	  
      
      let tempClients = (await ClientsService.index(this.search)).data
      if (tempClients) {
        console.log('mounted')
        await this.emitMethod('searchGroupClients', tempClients, this.search) 
      }

	},
  methods: {
    async emitMethod (name, value, value2) {
      if (value !== null && value !== undefined) {
          await EventBus.$emit(name, value, value2)
      }
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/EditClientsInGroup/EditClientsGroupSearchPanel.vue